import React from "react";
import { useSelector } from "react-redux";
import { getThemeColor, getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";

const ShowActionButtons = () => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const themeColor = JSON.parse(useSelector(getThemeColor));

  const ActionLinks = userDetails?.action ? JSON.parse(userDetails?.action) : [];

  return (
    <div className="mt-7 grid grid-rows-1 gap-3 w-full">
      {ActionLinks?.map((button, index) => (
        <a href={button?.link} target="_blank" key={index} rel="noreferrer" className="animate-fade-slide-in">
          <button
            className="px-3 py-1.5 rounded-lg w-full lg:w-72"
            style={{
              color: themeColor?.btnText,
              backgroundColor: themeColor?.btnBg,
            }}
          >
            {button?.name}
          </button>
        </a>
      ))}
    </div>
  );
};

export default ShowActionButtons;
